import store from '../../../vuex/store';

const illegality_val = [ undefined, null, '' ]
const new_title_mapping_keys = () => ({
  expense_nature_id: 0,
  customer_function_id: 0,
  customer_type: null,
  item_type_id: 0,
  is_insider_trading: false,
})
const new_title_mapping = {
  id: 0,
  expense_nature_id: 0,
  customer_function_id: 0,
  customer_type: null,
  item_type_id: 0,
  is_insider_trading: false,
  account_title_id: 0,
  analysis_title_id: 0,
  remark: '',
  fund_usage_id: 0
}

const functionHashName = (title_mapping) => {
  const m = title_mapping;
  return `${m.expense_nature_id}-${m.customer_function_id || 0}-${m.customer_type}-${m.item_type_id || 0}-${m.fund_usage_id || 0}-${m.is_insider_trading || false}`;
}

export function judgeThisKey(target, key) {
  if (illegality_val.includes(target[key])) {
    return false
  }
  const current_val = target[key]
  const default_val = illegality_val[key]
  return !(current_val === default_val)
}

export default {
  new_title_mapping: new_title_mapping,
  functionHashName: functionHashName,
  // obj must has those keys [expense_nature_id, customer_function_id, customer_type, item_type_id, fund_usage_id, is_insider_trading]
  getByNatureObj: (obj) => {
    const key = functionHashName(obj);
    const title_mapping = store.getters['async/title_mapping_ids_hash'][key];
    return title_mapping ? title_mapping : new_title_mapping;
  }
}
